const Home = () => {
    return (
        <>
        <h1>OlÁ</h1>
        </>
    )
}

export default Home;